// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"_0-z","upvoteIcon":"a1-z","downvoteIcon":"b1-z","feedbackIcon":"c1-z"};